// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_bgContainer__cEgyU {
  display: flex;
  margin-top: 62rem;
  width: 100%;
  justify-content: center;
  align-content: center;
  background-color: #1d2939;
}
@media only screen and (max-width: 700px) {
  .Footer_bgContainer__cEgyU {
    margin-top: 35rem;
  }
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1920rem;
  height: fit-content;
  padding: 32rem 48rem;
  gap: 16rem;
}
@media only screen and (max-width: 700px) {
  .Footer_bgContainer__cEgyU .Footer_footer__LNrAe {
    padding: 24rem 16rem;
  }
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP {
  position: relative;
  display: flex;
  flex-direction: row;
}
@media only screen and (max-width: 700px) {
  .Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP {
    gap: 32rem;
    flex-direction: column;
  }
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_firstInfoContainer__Ah4Vx {
  display: flex;
  flex-direction: column;
  width: 592rem;
  gap: 8rem;
}
@media only screen and (max-width: 700px) {
  .Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_firstInfoContainer__Ah4Vx {
    width: 100%;
  }
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_firstInfoContainer__Ah4Vx .Footer_logo__9QklP {
  width: 136rem;
  height: 56rem;
  stroke: #98a2b3;
  fill: #98a2b3;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_firstInfoContainer__Ah4Vx .Footer_companyInfo__yKP2q {
  display: flex;
  flex-direction: column;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_firstInfoContainer__Ah4Vx .Footer_companyInfo__yKP2q * {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16rem;
  line-height: 24rem;
  color: #98a2b3;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_secondInfoContainer__Jupj8 {
  display: flex;
  flex-direction: column;
  gap: 12rem;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_secondInfoContainer__Jupj8 * {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16rem;
  line-height: 24rem;
  color: #98a2b3;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_secondInfoContainer__Jupj8 .Footer_support__xTurF {
  gap: 6rem;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_secondInfoContainer__Jupj8 .Footer_support__xTurF .Footer_number__C6kWZ {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 32rem;
  line-height: 42rem;
  color: #ffffff;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_secondInfoContainer__Jupj8 .Footer_support__xTurF .Footer_email__jzVSU {
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20rem;
  line-height: 28rem;
  color: #ffffff;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_secondInfoContainer__Jupj8 .Footer_address__CgjQ9 {
  max-width: 245rem;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_thirdInfoContainer__kyTyx {
  position: absolute;
  display: flex;
  flex-direction: column;
  right: 0;
  bottom: 0;
  width: 345rem;
  gap: 8rem;
}
@media only screen and (max-width: 700px) {
  .Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_thirdInfoContainer__kyTyx {
    position: relative;
  }
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_thirdInfoContainer__kyTyx * {
  top: 0;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16rem;
  line-height: 24rem;
  color: #98a2b3;
}
@media only screen and (max-width: 700px) {
  .Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_thirdInfoContainer__kyTyx .Footer_license__NtaX1 {
    display: none;
  }
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_thirdInfoContainer__kyTyx .Footer_year__UBZHL {
  top: auto;
  margin-left: auto;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16rem;
  line-height: 24rem;
  color: #ffffff;
}
@media only screen and (max-width: 700px) {
  .Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_thirdInfoContainer__kyTyx .Footer_year__UBZHL {
    margin-left: 0;
  }
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyInfoContainer__GEHSP .Footer_thirdInfoContainer__kyTyx a:hover {
  text-decoration: underline;
}
.Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyName__YTLsv {
  max-width: 1920rem;
  width: 100%;
  height: fit-content;
  font-family: "Vivl Rail", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 180rem;
  line-height: 180rem;
  color: #667085;
}
@media only screen and (max-width: 700px) {
  .Footer_bgContainer__cEgyU .Footer_footer__LNrAe .Footer_companyName__YTLsv {
    font-family: "Vivl Rail", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 35rem;
    line-height: 35rem;
    color: #667085;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Footer/ui/Footer.module.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;EACA,qBAAA;EACA,yBCIS;ADNX;AEmIE;EFvIF;IASI,iBAAA;EADF;AACF;AAGE;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EAEA,oBAAA;EACA,UAAA;AAFJ;AEqHE;EF3HA;IAWI,oBAAA;EADJ;AACF;AAGI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AADN;AE2GE;EF7GE;IAMI,UAAA;IACA,sBAAA;EAAN;AACF;AAEM;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EAEA,SAAA;AADR;AE+FE;EFnGI;IAQI,WAAA;EAAR;AACF;AAEQ;EACE,aAAA;EACA,aAAA;EACA,eC5CC;ED6CD,aC7CC;AD6CX;AAGQ;EACE,aAAA;EACA,sBAAA;AADV;AAGU;EE1DR,iCDFU;ECGV,kBAAA;EACA,gBFyD0C;EExD1C,gBAAA;EACA,kBAAA;EACA,cDCS;ADyDX;AAGM;EACE,aAAA;EACA,sBAAA;EAEA,UAAA;AAFR;AAIQ;EExEN,iCDFU;ECGV,kBAAA;EACA,gBFuEwC;EEtExC,gBAAA;EACA,kBAAA;EACA,cDCS;ADsEX;AAAQ;EACE,SAAA;AAEV;AAAU;EE/ER,iCDFU;ECGV,kBAAA;EACA,gBF8EuC;EE7EvC,gBAAA;EACA,kBAAA;EACA,cD4BM;ADsDR;AALU;EElFR,iCDFU;ECGV,kBAAA;EACA,gBFiFuC;EEhFvC,gBAAA;EACA,kBAAA;EACA,cD4BM;AD8DR;AARQ;EACE,iBAAA;AAUV;AAHM;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EAEA,SAAA;AAIR;AE4BE;EFxCI;IAWI,kBAAA;EAKR;AACF;AAHQ;EACE,MAAA;EE9GR,iCDFU;ECGV,kBAAA;EACA,gBF6GwC;EE5GxC,gBAAA;EACA,kBAAA;EACA,cDCS;ADmHX;AEcE;EFrBM;IAEI,aAAA;EASV;AACF;AANQ;EACE,SAAA;EACA,iBAAA;EE1HR,iCDFU;ECGV,kBAAA;EACA,gBF0HqC;EEzHrC,gBAAA;EACA,kBAAA;EACA,cD4BM;ADuGR;AEDE;EFfM;IAOI,cAAA;EAaV;AACF;AATU;EACE,0BAAA;AAWZ;AALI;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EE9IJ,oCDHW;ECIX,kBAAA;EACA,gBF6IsC;EE5ItC,iBAAA;EACA,mBAAA;EACA,cDES;ADoJX;AEpBE;EFIE;IE3IF,oCDHW;ICIX,kBAAA;IACA,gBFgJsC;IE/ItC,gBAAA;IACA,kBAAA;IACA,cDES;ED6JT;AACF","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n.bgContainer {\n  display: flex;\n  margin-top: 62rem;\n  width: 100%;\n  justify-content: center;\n  align-content: center;\n  background-color: $gray-800;\n\n  @include mobile {\n    margin-top: 35rem;\n  }\n\n  .footer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    max-width: 1920rem;\n    height: fit-content;\n\n    padding: 32rem 48rem;\n    gap: 16rem;\n\n    @include mobile {\n      padding: 24rem 16rem;\n    }\n\n    .companyInfoContainer {\n      position: relative;\n      display: flex;\n      flex-direction: row;\n\n      @include mobile {\n        gap: 32rem;\n        flex-direction: column;\n      }\n\n      .firstInfoContainer {\n        display: flex;\n        flex-direction: column;\n        width: 592rem;\n\n        gap: 8rem;\n\n        @include mobile {\n          width: 100%;\n        }\n\n        .logo {\n          width: 136rem;\n          height: 56rem;\n          stroke: $gray-400;\n          fill: $gray-400;\n        }\n\n        .companyInfo {\n          display: flex;\n          flex-direction: column;\n\n          * {\n            @include fnt(16, 24, $gray-400, 400);\n          }\n        }\n\n\n      }\n\n      .secondInfoContainer {\n        display: flex;\n        flex-direction: column;\n\n        gap: 12rem;\n\n        * {\n          @include fnt(16, 24, $gray-400, 400);\n        }\n\n        .support {\n          gap: 6rem;\n\n          .number {\n            @include fnt(32, 42, $white, 400);\n          }\n          .email {\n            @include fnt(20, 28, $white, 400);\n          }\n        }\n\n        .address {\n          max-width: 245rem;\n          //@include mobile {\n          //  max-width: 255rem;\n          //}\n        }\n      }\n\n      .thirdInfoContainer {\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        right: 0;\n        bottom: 0;\n        width: 345rem;\n\n        gap: 8rem;\n\n        @include mobile {\n          position: relative;\n        }\n\n        * {\n          top: 0;\n          @include fnt(16, 24, $gray-400, 400);\n        }\n\n        .license {\n          @include mobile {\n            display: none;\n          }\n        }\n\n        .year {\n          top:auto;\n          margin-left: auto;\n\n          @include fnt(16, 24, $white, 400);\n\n          @include mobile {\n            margin-left: 0;\n          }\n        }\n\n        a {\n          &:hover {\n            text-decoration: underline;\n          }\n        }\n      }\n    }\n\n    .companyName {\n      max-width: 1920rem;\n      width: 100%;\n      height: fit-content;\n      @include fnt(180, 180, $gray-500, 400, $font-title);\n\n      @include mobile {\n        @include fnt(35, 35, $gray-500, 400, $font-title);\n      }\n    }\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;","@use \"variables\" as *;\n\n@mixin fnt($size: 16, $height: 24, $color: $black, $weight: 400, $font: $font-text, $unit: \"rem\") {\n  font-family: $font;\n  font-style: normal;\n  font-weight: $weight;\n  font-size: #{$size}#{$unit};\n  line-height: #{$height}#{$unit};\n  color: $color;\n}\n\n@mixin scrollable {\n  display: flex;\n  overflow-x: auto;\n\n  gap: 24rem;\n  margin-top: 32rem;\n  padding: 0 48rem;\n\n  @media(min-width: #{$main-container + 1}px) {\n    padding: 0 calc((100vw - #{$main-container}px) / 2);\n  }\n\n  @include mobile {\n    margin-top: 16rem;\n    gap: 16rem;\n    padding: 0 16rem;\n  }\n}\n\n@mixin container($margin: 124rem auto) {\n  margin: $margin;\n  width: 100%;\n  padding: 0 48px;\n  @media (min-width: #{$main-container + 1}px) {\n    width: #{$main-container + 32}px;\n\n  }\n  @include mobile {\n    padding: 0 16rem;\n  }\n}\n\n@mixin scrollButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: end;\n  height: fit-content;\n  width: fit-content;\n  gap: 16rem;\n\n  @include mobile {\n    display: none;\n  }\n}\n\n@mixin sectionHeader {\n  display: inline;\n  gap: 24rem;\n\n  img {\n    height: 68rem;\n    width: 68rem;\n    margin-right: 12rem;\n    @include mobile {\n      height: 42rem;\n      width: 42rem;\n    }\n  }\n\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n  @include mobile {\n    @include fnt(32, 42, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin header {\n  width: 100%;\n  padding: 0 48rem;\n  height: fit-content;\n  @include sectionHeader;\n  @include mobile {\n    padding: 0 16rem;\n  }\n  @content\n}\n\n@mixin textToMobile {\n  @include fnt(20, 24, $gray-400, 400, $font-text);\n  @include mobile {\n    @include fnt(16, 20, $gray-400, 400, $font-text);\n  }\n}\n\n@mixin inputField {\n  border-radius: 12rem;\n  padding: 16rem 20rem;\n\n  background-color: $white;\n  border: 1px $gray-300 solid;\n\n  @include mobile {\n    padding: 12rem 16rem;\n  }\n\n  @include textToMobile;\n\n  &::placeholder {\n    @include textToMobile;\n  }\n\n  * {\n    @include textToMobile;\n  }\n\n  &:active {\n    border: 1px $gray-700, solid;\n  }\n\n  &:hover {\n    border: 1px $gray-400, solid;\n  }\n\n  &error {\n    @include fnt(16, 24, $error-300, 500, $font-text);\n    @include mobile {\n      @include fnt(12, 24, $error-300, 500, $font-text);\n    }\n    border: 1px $error-500, solid;\n\n    * {\n      color: $error-300;\n    }\n  }\n}\n\n@mixin mobile {\n  @media only screen and (max-width: #{$mobile-width}px) {\n    @content;\n  }\n}\n\n@mixin laptop {\n  @media only screen and (max-width: #{$laptop-width}px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: #{$tablet-width}px) {\n    @content;\n  }\n}\n\n@mixin hd {\n  @media only screen and (max-width: #{$hd-width}px) {\n    @content;\n  }\n}\n\n@mixin hd-plus {\n  @media only screen and (min-width: #{$hd-width}px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bgContainer": `Footer_bgContainer__cEgyU`,
	"footer": `Footer_footer__LNrAe`,
	"companyInfoContainer": `Footer_companyInfoContainer__GEHSP`,
	"firstInfoContainer": `Footer_firstInfoContainer__Ah4Vx`,
	"logo": `Footer_logo__9QklP`,
	"companyInfo": `Footer_companyInfo__yKP2q`,
	"secondInfoContainer": `Footer_secondInfoContainer__Jupj8`,
	"support": `Footer_support__xTurF`,
	"number": `Footer_number__C6kWZ`,
	"email": `Footer_email__jzVSU`,
	"address": `Footer_address__CgjQ9`,
	"thirdInfoContainer": `Footer_thirdInfoContainer__kyTyx`,
	"license": `Footer_license__NtaX1`,
	"year": `Footer_year__UBZHL`,
	"companyName": `Footer_companyName__YTLsv`
};
export default ___CSS_LOADER_EXPORT___;
